import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { Multiple } from '../../../components/multiple-text-blurb-for-grid';
import UserDateTimezoneFormat from '../../../components/user-date-timezone-format';
import { messages } from './messages';

const OrderDateComponent = ({ fulfillmentPlanId, salesOrderId, isExpanded }) => {
  const orderDateTime = useSelector((state) =>
    Global.selectEntitiesSalesOrderProperty(state, {
      salesOrderId,
      property: 'orderDateTime',
    }),
  );
  const salesOrdersFulfilledIds = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'salesOrdersFulfilledIds',
    }),
  );

  if (!isExpanded && salesOrdersFulfilledIds?.length > 1) {
    return <Multiple />;
  }

  if (!orderDateTime) {
    return null;
  }
  return <UserDateTimezoneFormat dateTime={orderDateTime} />;
};

OrderDateComponent.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
};

export const OrderDate = {
  getMessageDescriptor: () => messages.orderDate,
  id: 'orderDate',

  render: (data, { isExpanded = false, isFirstOfType = true } = {}) => {
    if (!data || !isFirstOfType) {
      return null;
    }

    return <OrderDateComponent fulfillmentPlanId={data.id} isExpanded={isExpanded} salesOrderId={data.salesOrderId} />;
  },
};
